<script>
import { defineComponent as _defineComponent } from "vue";
import { unref as _unref, renderSlot as _renderSlot, vShow as _vShow, withModifiers as _withModifiers, createElementVNode as _createElementVNode, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, createVNode as _createVNode, mergeProps as _mergeProps, Teleport as _Teleport } from "vue";
const _hoisted_1 = ["data-id"];
import {
  ref,
  watch,
  nextTick,
  toValue,
  onBeforeUnmount,
  onUnmounted
} from "vue";
import { createDefu } from "defu";
import { onKeyStroke } from "@vueuse/core";
import { defaultOptions } from "./../utils/defaultOptions";
import { useModalDOM } from "../composables/private/useModalDOM";
import { useModalCallback } from "../composables/private/useModalCallback";
import { useMagicModal } from "../composables/useMagicModal";
import "@maas/vue-equipment/utils/css/animations/fade-in.css";
import "@maas/vue-equipment/utils/css/animations/fade-out.css";
export default /* @__PURE__ */ _defineComponent({
  ...{
    inheritAttrs: false
  },
  __name: "MagicModal",
  props: {
    id: { type: null, required: true },
    props: { type: Object, required: false },
    options: { type: Object, required: false, default: () => ({}) }
  },
  setup(__props) {
    const customDefu = createDefu((obj, key, value) => {
      if (key === "close") {
        obj[key] = value;
        return true;
      }
    });
    const mappedOptions = customDefu(__props.options, defaultOptions);
    const modalRef = ref(void 0);
    const {
      trapFocus,
      releaseFocus,
      lockScroll,
      unlockScroll,
      addScrollLockPadding,
      removeScrollLockPadding
    } = useModalDOM({
      focusTarget: modalRef,
      focusTrap: mappedOptions.focusTrap
    });
    const { isActive, close } = useMagicModal(__props.id);
    const innerActive = ref(false);
    const wrapperActive = ref(false);
    const {
      onBeforeEnter,
      onEnter,
      onAfterEnter,
      onBeforeLeave,
      onLeave,
      onAfterLeave
    } = useModalCallback({
      id: __props.id,
      mappedOptions,
      addScrollLockPadding,
      removeScrollLockPadding,
      lockScroll,
      unlockScroll,
      trapFocus,
      releaseFocus,
      wrapperActive
    });
    async function onOpen() {
      wrapperActive.value = true;
      await nextTick();
      innerActive.value = true;
    }
    function onClose() {
      innerActive.value = false;
    }
    if (mappedOptions.keyListener?.close) {
      for (const key of mappedOptions.keyListener.close) {
        onKeyStroke(key, (e) => {
          close();
          e.preventDefault();
        });
      }
    }
    watch(isActive, async (value) => {
      if (value) {
        await onOpen();
      } else {
        onClose();
      }
    });
    onBeforeUnmount(() => {
      close();
    });
    onUnmounted(() => {
      if (mappedOptions.scrollLock) {
        unlockScroll();
        if (typeof mappedOptions.scrollLock === "object" && mappedOptions.scrollLock.padding) {
          removeScrollLockPadding();
        }
      }
      if (mappedOptions.focusTrap) {
        releaseFocus();
      }
    });
    return (_ctx, _cache) => {
      return wrapperActive.value ? (_openBlock(), _createBlock(_Teleport, {
        key: 0,
        to: _unref(mappedOptions).teleport?.target,
        disabled: _unref(mappedOptions).teleport?.disabled
      }, [
        _createElementVNode("div", _mergeProps({
          ref_key: "modalRef",
          ref: modalRef,
          class: "magic-modal",
          "data-id": toValue(_ctx.id)
        }, _ctx.$attrs, {
          "aria-modal": "true",
          onClick: _cache[1] || (_cache[1] = _withModifiers(
            //@ts-ignore
            (...args) => _unref(close) && _unref(close)(...args),
            ["self"]
          ))
        }), [
          _unref(mappedOptions).backdrop || !!_ctx.$slots.backdrop ? (_openBlock(), _createBlock(_Transition, {
            key: 0,
            name: _unref(mappedOptions).transition?.backdrop,
            persisted: ""
          }, {
            default: _withCtx(() => [
              _withDirectives(_createElementVNode(
                "div",
                {
                  class: "magic-modal__backdrop",
                  onClick: _cache[0] || (_cache[0] = _withModifiers(
                    //@ts-ignore
                    (...args) => _unref(close) && _unref(close)(...args),
                    ["self"]
                  ))
                },
                [
                  _renderSlot(_ctx.$slots, "backdrop")
                ],
                512
                /* NEED_PATCH */
              ), [
                [_vShow, innerActive.value]
              ])
            ]),
            _: 3
            /* FORWARDED */
          }, 8, ["name"])) : _createCommentVNode("v-if", true),
          _createVNode(_Transition, {
            name: _unref(mappedOptions).transition?.content,
            onBeforeLeave: _unref(onBeforeLeave),
            onLeave: _unref(onLeave),
            onAfterLeave: _unref(onAfterLeave),
            onBeforeEnter: _unref(onBeforeEnter),
            onEnter: _unref(onEnter),
            onAfterEnter: _unref(onAfterEnter),
            persisted: ""
          }, {
            default: _withCtx(() => [
              _withDirectives((_openBlock(), _createBlock(_resolveDynamicComponent(_unref(mappedOptions).tag), {
                class: "magic-modal__content",
                onClick: _withModifiers(_unref(close), ["self"])
              }, {
                default: _withCtx(() => [
                  _renderSlot(_ctx.$slots, "default")
                ]),
                _: 3
                /* FORWARDED */
              }, 8, ["onClick"])), [
                [_vShow, innerActive.value]
              ])
            ]),
            _: 3
            /* FORWARDED */
          }, 8, ["name", "onBeforeLeave", "onLeave", "onAfterLeave", "onBeforeEnter", "onEnter", "onAfterEnter"])
        ], 16, _hoisted_1)
      ], 8, ["to", "disabled"])) : _createCommentVNode("v-if", true);
    };
  }
});
</script>

<style>
@keyframes mm-content-enter {
  0% {
    opacity: 0;
    transform: translate3d(0, 2rem, 0);
  }
  100% {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }
}

@keyframes mm-content-leave {
  0% {
    opacity: 1;
    transform: scale(1);
  }
  100% {
    opacity: 0;
    transform: scale(1.02);
  }
}

.magic-modal {
  position: fixed;
  inset: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: var(--magic-modal-z-index, 999);
  background: transparent;
  color: inherit;
  padding: 0;
  border: none;
}

.magic-modal__content {
  -webkit-overflow-scrolling: touch;
  scroll-behavior: smooth;
  max-height: 100%;
  width: 100%;
  display: flex;
  align-items: var(--magic-modal-content-align-items, center);
  justify-content: var(--magic-modal-content-justify-content, center);
  overflow-y: var(--magic-modal-content-overflow-y, auto);
}

/* Reset default dialog styles */
dialog.magic-modal__content {
  margin: 0;
  padding: 0;
  border: 0;
  background: transparent;
  outline: 0;
}

dialog.magic-modal__content::backdrop {
  background-color: transparent;
}

.magic-modal__backdrop {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  background-color: var(--magic-modal-backdrop-color, rgba(0, 0, 0, 0.5));
  backdrop-filter: var(--magic-modal-backdrop-filter, unset);
  z-index: -1;
}

/* Content */
.magic-modal-content-enter-active {
  animation: mm-content-enter 175ms ease;
}

.magic-modal-content-leave-active {
  animation: mm-content-leave 175ms ease;
}

@media (prefers-reduced-motion) {
  .magic-modal-content-enter-active {
    animation: fade-in 175ms ease;
  }

  .magic-modal-content-leave-active {
    animation: fade-out 175ms ease;
  }
}

/* Backdrop */
.magic-modal-backdrop-enter-active {
  animation: fade-in 175ms ease;
}

.magic-modal-backdrop-leave-active {
  animation: fade-out 175ms ease;
}
</style>
